import * as React from 'react';
import classnames from 'classnames';

import './insights-reports-callout.scss';

type Props = {
  headerText?: string,
  body?: string,
  button: React.ReactNode,
  className?: string
};

class InsightsReportsCallout extends React.PureComponent<Props> {
  renderHeader(): React.ReactNode {
    const { headerText } = this.props;

    return (
      <div className="insights-reports-callout__header">
        {headerText}
      </div>
    );
  }

  renderBody(): React.ReactNode {
    const { body } = this.props;

    return (
      <div className="insights-reports-callout__body">
        {body}
      </div>
    );
  }

  renderButton(): React.ReactNode {
    const { button } = this.props;

    return (
      <div className="insights-reports-callout__button">
        {button}
      </div>
    );
  }

  render(): React.ReactNode {
    const { className } = this.props;
    const calloutClasses = classnames('insights-reports-callout', className);

    return (
      <div className={calloutClasses}>
        {this.renderHeader()}
        {this.renderBody()}
        {this.renderButton()}
      </div>
    );
  }
}

export default InsightsReportsCallout;
